export const MAX_VIDEO_DURATION = 600; // 10分钟 = 600秒
export const MAX_VIDEO_NUM = 1;
